import { useState, useRef, useCallback, useMemo, useEffect, useLayoutEffect } from "react";
import { createContext, useContext } from "react";

export interface PopupOption {
  title: string;
  maxWidth: string;
}

export interface PopupAction {
  id: string;
  label: string;
  onClick: () => void;
  position?: "left" | "right";
  className?: string;
  variant?: "text" | "outlined" | "contained";
  autoFocus?: boolean;
  disabled?: boolean;
}

export const defPopupAction: PopupAction = {
  id: "",
  label: "",
  onClick: () => {}
}

export interface PopupContextType {
  option: PopupOption;
  setOption: (option: PopupOption) => void;
  actions: PopupAction[];
  setActions: (actions: PopupAction[]) => void;
  onClose: (data?: any) => void;
}

export const PopupContext = createContext<PopupContextType | null>(null);

export const usePopup = (): PopupContextType => {
  const context = useContext(PopupContext)
  if (!context) {
    throw new Error("usePopup은 CommonPopup 내부에서만 사용 가능합니다");
  }
  return context;
}
